'use client'

import React from 'react'
import { Person } from '@/payload-types'
import Image from 'next/image'
import { isMedia } from '@/lib/utils'

interface PreviewPersonProps {
  person: Person
}

const initials = (str: string) =>
  str
    .split(' ')
    .filter(Boolean)
    .map((word) => word[0])
    .join('')

function PreviewPerson({ person }: Readonly<PreviewPersonProps>): React.ReactNode {
  const photo = person.photo

  return (
    <div key={person.id} className="relative group flex flex-row gap-4">
      <figure className="relative bg-muted aspect-square size-10 flex justify-center items-center">
        {photo && isMedia(photo) ? (
          <Image src={photo.url!} alt={photo.alt || person.name} fill objectFit="cover" />
        ) : (
          <figcaption className="cursor-default flex justify-center items-center size-10 font-semibold text-2xl rounded-full bg-foreground/10">
            {initials(person.name)}
          </figcaption>
        )}
      </figure>
      <div className="flex flex-col gap-1">
        <h3 className="font-semibold text-base leading-tight">{person.name}</h3>
        {person.position ? (
          <p className="text-sm text-muted-foreground line-clamp-3">{person.position}</p>
        ) : null}
      </div>
    </div>
  )
}

export { PreviewPerson, type PreviewPersonProps }
